import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Container } from '@mui/material'

const NotFound = () => {
  return (
      <Container sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }} maxWidth={false} disableGutters>
        <Header/>
        <Container component='main' maxWidth={false} sx={{ flex: 1 }} disableGutters>
          <div data-testid="not-found-section">
            NotFound
          </div>
        </Container>
        <Footer/>
      </Container>
  )
}

export default NotFound